import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const DRAFT_TTL_MS = 30 * 60 * 1000; // 30 minutes

interface BulkImportDraft {
  uuid: string;
  step: number;
  createdAt: number;
}

interface BulkImportState {
  draft: BulkImportDraft | null;
  setPendingImport: (uid: string, step?: number) => void;
  clearPendingImport: () => void;
  isDraftValid: () => boolean;
  getDraft: () => BulkImportDraft | null;
}

export const useBulkImportStore = create<BulkImportState>()(
  persist(
    (set, get) => ({
      draft: null,
      setPendingImport: (uid, step = 2) =>
        set({
          draft: {
            uuid: uid,
            step,
            createdAt: Date.now(),
          },
        }),
      clearPendingImport: () => set({ draft: null }),
      isDraftValid: () => {
        const { draft } = get();
        if (!draft) return false;
        const now = Date.now();
        const isExpired = now - draft.createdAt > DRAFT_TTL_MS;
        if (isExpired) {
          set({ draft: null });
          return false;
        }
        return true;
      },
      getDraft: () => {
        const { draft, isDraftValid } = get();
        return isDraftValid() ? draft : null;
      },
    }),
    {
      name: 'bulk-import-storage',
    },
  ),
);
